import {
  getErrorMessage,
  getAuthenticationHeaders,
  generateQueryString,
  generateObjectFromList,
  getErrorMessageForBlob,
} from './utils';

import apiProvider from './provider';
import {
  SUMMARY_DASHBOARD_GET_CONTAINERS,
  SUMMARY_DASHBOARD_DOWNLOAD_CONTAINER_DATA,
  SUMMARY_DASHBOARD_DOWNLOAD_SHIPMENT_DATA,
  GET_META_DATA,
  GET_CHART_DATA,
  SUMMARY_DASHBOARD_CUSTOMER_SEARCH,
  SUMMARY_DASHBOARD_GET_SHIPMENTS,
} from './routes';
import { API_BASE_URL } from '../globals';
import { AxiosResponse } from 'axios';
import { ApiResponseWrapper } from './apiHandler';

export const downloadContainersApi = async (body)  => {
  try {
    const response = await apiProvider
    .post(`${API_BASE_URL}${SUMMARY_DASHBOARD_DOWNLOAD_CONTAINER_DATA}`,
    body,
      {
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      },
    );
    return {
      isSuccess : true,
      data: response,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadShipmentsApi = async (body)  => {
  try {
    const response = await apiProvider
    .post(`${API_BASE_URL}${SUMMARY_DASHBOARD_DOWNLOAD_SHIPMENT_DATA}`,
    body,
      {
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      },
    );
    return {
      isSuccess : true,
      data: response,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getCustomers = async (params)  => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(
      `${API_BASE_URL}${SUMMARY_DASHBOARD_CUSTOMER_SEARCH}`,
      {
        params,
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess : true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchContainerListApi = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${SUMMARY_DASHBOARD_GET_CONTAINERS}`,
    body,
    { headers: getAuthenticationHeaders() },
    );
    return {
      isSuccess : true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const fetchShipmentListApi = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${SUMMARY_DASHBOARD_GET_SHIPMENTS}`,
    body,
    { headers: getAuthenticationHeaders() },
    );
    return {
      isSuccess : true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const fetchMetaDataApi = async () => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(`${API_BASE_URL}${GET_META_DATA}`,
      { headers: getAuthenticationHeaders() },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchChartData = async (params) => {
  try {
    let paramArray: any = [];
    for (const key in params) {
      if (Array.isArray(params[key])) {
        const paramData = generateObjectFromList(key, params[key]);
        paramArray = paramArray.concat(paramData);
      } else {
        const obj = { key, val: params[key] };
        paramArray.push(obj);
      }
    }

    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider
    .get(`${API_BASE_URL}${GET_CHART_DATA}?${generateQueryString(paramArray)}`,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
